import { DottedGlowBackground } from '@repo/ui/aceternity/dotted-glow-background'
import {
	createFileRoute,
	isRedirect,
	Outlet,
	redirect
} from '@tanstack/react-router'
import { adminSessionQueryOptions } from '@/lib/query-options'

export const Route = createFileRoute('/(auth)')({
	ssr: false,
	beforeLoad: async ({ context }) => {
		// Cache-first on purpose: this layout re-runs on every child navigation
		// and preload, so it must never fetch when the session is already cached.
		// The cache is kept accurate by the auth events themselves (sign-in flows
		// run fetchFreshSession, logout and 401 recovery clear the cache).
		try {
			const session = await context.queryClient.fetchQuery(
				adminSessionQueryOptions()
			)

			if (session.sessionType === 'authenticated') {
				throw redirect({ to: '/' })
			}
		} catch (error) {
			if (isRedirect(error)) {
				throw error
			}
			// Best-effort check: the auth pages must render even when the
			// session fetch fails.
		}
	},
	// The auth screens sit on the app shell's canvas, lit softly from the top,
	// with the screen's own sheet centred on it: the same surfaces the app uses
	// once signed in, so the login is the first page of the product, not a splash.
	// A field of faintly pulsing ink dots gives the canvas some matter; it fades
	// out toward the centre so the form never sits on a pattern.
	component: () => (
		<div className='relative isolate flex min-h-svh flex-col bg-[radial-gradient(ellipse_80%_60%_at_50%_0%,var(--background),transparent_70%)] bg-sidebar p-6'>
			<DottedGlowBackground
				className='-z-10 [mask-image:radial-gradient(ellipse_70%_70%_at_50%_50%,transparent_30%,black_85%)]'
				colorVar='--muted-foreground'
				gap={18}
				glowColorVar='--primary'
				opacity={0.45}
				radius={1.1}
				speedMax={0.9}
				speedMin={0.25}
			/>
			<main className='m-auto w-full max-w-md rounded-xl bg-background p-8 shadow-[0_0_0_1px_var(--sidebar-border),0_16px_40px_-20px_oklch(0.3_0.02_55/0.22)]'>
				<Outlet />
			</main>
		</div>
	)
})
